import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetChallengeRateLimitResponse } from './get-challenge-rate-limit-response';
import { getChallengeRateLimitResponseSchema } from './get-challenge-rate-limit-response';

export async function getChallengeRateLimitApi(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetChallengeRateLimitResponse>> {
  return getRequest<IGetChallengeRateLimitResponse>({
    path: '/reviews/rate-limit',
    schema: getChallengeRateLimitResponseSchema,
    options,
  });
}
